import React from 'react';
import '../styles/Navbar.css';
import logo from '../assets/logo.png';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Navbar = () => {
  return (
    <>
      {/* Top Bar */}
      <div className="top-bar">
        <div className='topleft'>
          <FaMapMarkerAlt className="icon" />
F-3, Plot No. 20, Aditya Plaza, Shree Ram Nagar, Khirani Phatak Raad, Jhotwara, Jaipur, Raj. , 302012
        </div>
        <div className='top-right'>
          <FaEnvelope className="icon" />
         sales@aaohukum.com
        </div>
      </div>

      {/* Sticky Navbar */}
      <nav className="navbar">
        <div className="navbar-left">
          <img src={logo} alt="Logo" className="logo" />
        </div>

        <div className="navbar-right">
          <a href="tel:7597700113" className="call-button">
            <FaPhoneAlt className="icon" />
            +91 7597700113
          </a>
          <button className="plan-button">
            Plan Your Dream Trip
          </button>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
